import React, { useState, useEffect, useRef } from 'react';
import { Button, Col, Row, Modal, Form} from 'react-bootstrap';
import { useSelector } from "react-redux";
import APICom from "../../../utils/helpers/APICom";
import {Icon} from '@iconify/react';
import * as XLSX from 'xlsx';
import ExportIcon from "../../../assets/Images/CommonImages/save.png";
import ClearFilterIcon from "../../../assets/Images/CommonImages/clearFilter.png";
import GridControl from '../../Controls/gridControl';
import MapControlSkeleton from '../../Controls/mapControlSkeleton';

const DriverAlerts = (props = {}) => {
    const { NoShowReasonData,  GlobalASCSData, DispatchVehicleData, ZoneVerticesData, isLoading } = useSelector((store) => store.combinedata);
    const { loginData } = useSelector((store) => store.login);

    const [alertHasReturnTrip, setAlertHasReturnTrip] = useState(false);
    const [isReturnTripCheckBox, setIsReturnTripChecBox] = useState(false);
    const chkReturnTripRef = useRef();

    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalBodyHTML, setModalBodyHTML] = useState(null);
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [showInfoWindow, setShowInfoWindow] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    // const [affSelection, setAffSelection] = useState(0);
    const xCancelSourceForGrid = useRef(null);
    const generalDataofSelectedAlert = useRef([]);
    const AlertClickFlagRef = useRef(false);
    const responseDataRef = useRef([]);
    const selectedAlertSectionTypeRef = useRef("");
    const refreshBtnRef = useRef(null);
    const ResolveBtnRef = useRef(null);
    const affSelection = useRef(0);

    const noshowReasonRef = useRef();
    const [noShowReasons, setNoShowReasons] = useState([]);
    const [displayNoShowAlert, setDisplayNoShowAlert] = useState(false);
    const [noShowAlert, setNoShowAlert] = useState({alertTitle: '', alertMsg:''});
    // const infoWindowDP = useRef(<><span className="position-absolute" 
    //     onMouseOver={(e)=>{e.target.className="position-absolute fw-bold"}} onMouseLeave={(e)=>{e.target.className="position-absolute"}}
    //     onClick={(e)=>setShowInfoWindow(false)} style={{cursor:"pointer", fontSize:"medium", right:"2%", top:"-5px"}}>x</span>
    //     <p className="m-0">
    //     <span className='rounded-circle bg-success d-inline-flex' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>Online</span>
    //     <br></br>
    //     <span className='rounded-circle d-inline-flex' style={{backgroundColor:"#FF007F", height:"10px", width:"10px"}}></span><span className='mx-1'>UnAvailable</span>
    //     <br></br>
    //     <span className='rounded-circle d-inline-flex' style={{backgroundColor:"purple", height:"10px", width:"10px"}}></span><span className='mx-1'>IRTPU</span>
    //     <br></br>
    //     <span className='rounded-circle d-inline-flex bg-info' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>At Location</span>
    //     <br></br>
    //     <span className='rounded-circle d-inline-flex bg-warning' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>Occupied</span>
    //     <br></br>
    //     <span className='rounded-circle d-inline-flex' style={{backgroundColor:"yellow", height:"10px", width:"10px"}}></span><span className='mx-1'>On Break</span>
    //     <br></br>
    //     </p></>);
    const infoWindowState = useRef(<>
        <p className="m-0">
        <span className='fw-bold text-center w-100 d-block'>Status</span>
        <span className='rounded-circle bg-success d-inline-flex' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>Online</span>
        {/* <br></br> */}
        {/* <span className='rounded-circle d-inline-flex' style={{backgroundColor:"#FF007F", height:"10px", width:"10px"}}></span><span className='mx-1'>UnAvailable</span> */}
        <br></br>
        <span className='rounded-circle d-inline-flex' style={{backgroundColor:"purple", height:"10px", width:"10px"}}></span><span className='mx-1'>IRTPU</span>
        <br></br>
        <span className='rounded-circle d-inline-flex bg-info' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>At Location</span>
        <br></br>
        <span className='rounded-circle d-inline-flex bg-warning' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>Occupied</span>
        <br></br>
        <span className='rounded-circle d-inline-flex' style={{backgroundColor:"yellow", height:"10px", width:"10px"}}></span><span className='mx-1'>On Break</span>
        <br></br>
        <span className='rounded-circle d-inline-flex bg-secondary' style={{height:"10px", width:"10px"}}></span><span className='mx-1'>Disconnected</span>
        <br></br>
        </p></>);
    //------------------------------------Emergency Alert Data
    const [showEmergencyAlerts, setShowEmergencyAlerts] = useState(false);
    const [emergencyAlertResolved, setEmergencyAlertResolved] = useState(false);
    const [emergencyAlertStatusDescription, setEmergencyAlertStatusDescription] = useState("");
    const [emergencyAlertDriver, setEmergencyAlertDriver] = useState([]);
    const [emergencyAlertsTableData, setEmergencyAlertsTableData] = useState([]);

    const EmergencyBtnRef = useRef(null);
    const driverEmergencyAlertTableObj = useRef(null);
    //------------------------------------NoShow Data
    const [showNoShowAlerts, setShowNoShowAlerts] = useState(false);
    const [noshowAlertDriver, setNoShowAlertDriver] = useState([]);
    const [OARALoadData, setOARALoadData] = useState([]);
    const [noShowAlertsTableData, setNoShowAlertsTableData] = useState([]);
    const [noShowAlertStatusDescription, setNoShowAlertStatusDescription] = useState("");
    const [noShowStatusDropDown, setNoShowStatusDropDown] = useState("approved");
    const [noShowReasonDropDown, setNoShowReasonDropDown] = useState("defaultReason"); 

    const NoShowBtnRef = useRef(null);
    //------------------------------------LatePU Data
    const [showLateAlerts, setShowLateAlerts] = useState(false);
    const [latePUAlertDriver, setLatePUAlertDriver] = useState([]);
    const [latePUAlertsTableData, setLatePUAlertsTableData] = useState([]);
    const [latePUAlertStatusDescription, setLatePUAlertStatusDescription] = useState("");
    const [latePUAlertResolved, setLatePUAlertResolved] = useState(false);

    const LatePUBtnRef = useRef(null);
    // const [latePUAlertServiceID, setLatePUAlertServiceID] = useState(0);
    //------------------------------------Device Lock Data
    const [showDeviceAlerts, setShowDeviceAlerts] = useState(false);
    const [deviceLockAlertDriver, setDeviceLockAlertDriver] = useState([]);
    const [deviceLockAlertsTableData, setDeviceLockAlertsTableData] = useState([]);
    const [deviceLockStatusDescription, setDeviceLockStatusDescription] = useState("");
    const [deviceLockExpirationStartDate, setDeviceLockExpirationStartDate] = useState("");
    const [deviceLockExpirationStartTime, setDeviceLockExpirationStartTime] = useState("");
    const [deviceLockExpirationDuration, setDeviceLockExpirationDuration] = useState(0);
    const [deviceStatus, setDeviceStatus] = useState("Locked");

    const DeviceBtnRef = useRef(null);
    const deviceStatusBtnCheck = useRef(null);
    const deviceStatusTextRef = useRef(null);
    //------------------------------------Driver Penalty Data
    const [showDriverPenaltyAlerts, setShowDriverPenaltyAlerts] = useState(false);
    const [driverPenaltyAlertDriver, setDriverPenaltyAlertDriver] = useState([]);
    const [driverPenaltyAlertsTableData, setDriverPenaltyAlertsTableData] = useState([]);
    const [driverPenaltyStatusDescription, setDriverPenaltyStatusDescription] = useState("");
    const [penaltyStatus, setPenaltyStatus] = useState("Active");
    const [penaltyStatusExpiration, setPenaltyStatusExpiration] = useState("N/A");

    const DriverBtnRef = useRef(null);
    const penaltyStatusBtnCheck = useRef(null);
    const penaltyStatusTextRef = useRef(null);
    const driverPenaltyAlertTableObj = useRef(null);
    //------------------------------------Other Alerts Data
    const [showOthersAlerts, setShowOthersAlerts] = useState(false);
    const [otherAlertDriver, setOtherAlertDriver] = useState([]);
    const [otherAlertsTableData, setOtherAlertsTableData] = useState([]);
    const [otherAlertStatusDescription, setOtherAlertStatusDescription] = useState("");
    
    const OthersBtnRef = useRef(null);
    //------------------------------------Map Marker Data
    const [mapData, setMapData] = useState([]);
    //---------------------------------------------------Major Alerts Table------------------------------------------------------
    const [driverEmergencyAlertDisplay, setDriverEmergencyAlertDisplay] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: true,
        pagination: false,
        sortCondition: false,
        mapPolylines:{single:false,multiple:false},
        mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
        mapDefaultBtns: false,
        mapOptions: {tilt: 47.5, zoom: 9, zone: false},
        paginationMode: "local",
        paginationSize: 500,
        paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitColumns",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"emergencyAlert",
        paginationCounter:"",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "iAlertID",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"emergencyAlert"+'_Export" style="height:25px;">',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            driverEmergencyAlertTableObj.current = table;
            driverEmergencyAlertTableObj.current.selectRow( driverEmergencyAlertTableObj.current.getData()[0].iAlertID);
            let img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px; margin-top:-25%;"; 
                img.src = ExportIcon;
                document.getElementById("emergencyAlert_Export").appendChild(img);

            document.getElementById("emergencyAlert_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                let filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "Emergency Alerts Data");
                XLSX.writeFile(wb, "emergencyAlertTable_data.xlsx");
                
            });
        },
        rowSelectionChangeHandle: function(data){ 
            try{
                if(data.length > 0)
                {
                    // console.log(data);
                    let actualData = data[0];
                    let tripLatLng = [];
                    if(actualData.TripLat && actualData.TripLat !== "" && actualData.TripLat !== 0)
                    {
                        if(actualData.vAlertMessage && actualData.vAlertMessage.includes("Location") && actualData.vAlertMessage.includes("PU Person"))
                        {
                            let location = actualData.vAlertMessage.split("Location:")[1].split(", Away")[0];
                            let rider = actualData.vAlertMessage.split("PU Person:")[1].split(", Time")[0];
                            tripLatLng.push({lat:parseFloat(actualData.TripLat),lng: parseFloat(actualData.TripLong), Type:"PU", name:rider, address:location});
                        }
                        else
                        {
                            tripLatLng.push({lat:parseFloat(actualData.TripLat),lng: parseFloat(actualData.TripLong), Type:"PU", name:"N/A", address:"N/A"});
                        }
                    }
                    else if(actualData["Pickup Latitude"] && actualData["Pickup Latitude"] !== "" && actualData["Pickup Latitude"] !== 0)
                    {
                        let rider = actualData.PUPersonName?actualData.PUPersonName:["N/A"]
                        tripLatLng.push({lat:parseFloat(actualData["Pickup Latitude"]),lng: parseFloat(actualData["Pickup Longitude"]), Type:"PU", name:rider, address:actualData["Pickup Address"]});
                    }
//                    else
//                    {
//                        tripLatLng.push({lat:"",lng: "", Type:"PU", name:"N/A", address:"N/A"});
//                    }
                    if(actualData["DropOff Latitude"] && actualData["DropOff Latitude"] !== "" && actualData["DropOff Latitude"] !== 0)
                    {
                        let rider = actualData.PUPersonName?actualData.PUPersonName:["N/A"]
                        tripLatLng.push({lat:parseFloat(actualData["DropOff Latitude"]),lng: parseFloat(actualData["DropOff Longitude"]), Type:"DO", name:rider, address:actualData["DropOff Address"]});
                    }
//                    else
//                    {
//                        tripLatLng.push({lat:"",lng: "", Type:"DO", name:"N/A", address:"N/A"});
//                    }
                    
                    if(actualData.Lat && actualData.Lat !== "" && actualData.Lat !== 0)
                    {
                        tripLatLng.push({lat:parseFloat(actualData.Lat),lng: parseFloat(actualData.Long), 
                            Type:"Alert", description:actualData["Penalty Reason"]?actualData["Penalty Reason"]:actualData.vAlertMessage, 
                            name:selectedAlertSectionTypeRef.current.toUpperCase()+" Alert", address:"N/A"});
                    }
//                    else
//                    {
//                        tripLatLng.push({lat:"",lng: "", Type:"Alert",
//                            description:actualData["Penalty Reason"]?actualData["Penalty Reason"]:actualData.vAlertMessage,
//                            name:selectedAlertSectionTypeRef.current.toUpperCase()+ " Alert", address:"N/A"});
//                    }
                    if(actualData.LATITUDE && actualData.LATITUDE !== "" && actualData.LATITUDE !== 0)
                    {
                        tripLatLng.push({lat:parseFloat(actualData.LATITUDE),lng: parseFloat(actualData.LONGITUDE),
                            Type:"Alert", description:actualData["Penalty Reason"]?actualData["Penalty Reason"]:actualData.vAlertMessage?actualData.vAlertMessage:"Device Locked",
                            name:selectedAlertSectionTypeRef.current.toUpperCase()+" Alert", address:actualData.LOCATION?actualData.LOCATION:"N/A"});
                    }
                    if(actualData.DriverLat && actualData.DriverLat !== "" && actualData.DriverLat !== 0)
                    {
                        if(actualData["Alert Type"])
                        {
                            let vehicleNum =  "";
                            if(actualData.vAlertMessage.toLowerCase().includes("v:"))
                            {
                                vehicleNum = actualData.vAlertMessage.split(" ")[0].split(":")[1];
                            }
                            else if(actualData.vAlertMessage.toLowerCase().includes("veh#:"))
                            {
                                vehicleNum = actualData.vAlertMessage.replace(/\s/g, '').split(",")[1].split(":")[1];
                            }
                            tripLatLng.push({lat:parseFloat(actualData.DriverLat),lng: parseFloat(actualData.DriverLong), VehInfo:("" +" "+""), 
                            State: "ONLINE", Type:"Vehicle", VehNo:vehicleNum?vehicleNum:"N/A", 
                            DriverNo:actualData.iUserID?actualData.iUserID:"N/A", Distance:0});
                        }
                        else if(actualData["Alert Type"] === "")
                        {
                            let vehicleNum =  "";
                            if(actualData.vAlertMessage.toLowerCase().includes("v:"))
                            {
                                vehicleNum = actualData.vAlertMessage.split(" ")[0].split(":")[1];
                            }
                            else if(actualData.vAlertMessage.toLowerCase().includes("veh#:"))
                            {
                                vehicleNum = actualData.vAlertMessage.replace(/\s/g, '').split(",")[1].split(":")[1];
                            }
                            tripLatLng.push({lat:parseFloat(actualData.DriverLat),lng: parseFloat(actualData.DriverLong), VehInfo:("" +" "+""), 
                            State: "ONLINE", Type:"Vehicle", VehNo:vehicleNum?vehicleNum:"N/A", 
                            DriverNo:actualData.iUserID?actualData.iUserID:"N/A", Distance:0});
                        }
                        else
                        {
                            tripLatLng.push({lat:parseFloat(actualData.DriverLat),lng: parseFloat(actualData.DriverLong), VehInfo:("" +" "+""), 
                            State: "ONLINE", Type:"Vehicle", VehNo:actualData["Vehicle#"]?actualData["Vehicle#"]:"N/A", 
                            DriverNo:actualData["Driver#"]?actualData["Driver#"]:"N/A", Distance:0});
                        }
                    }
//                    else
//                    {
//                        tripLatLng.push({lat:"",lng: "", VehInfo:("" +" "+""),
//                        State: "ONLINE", Type:"Vehicle", VehNo:actualData["Vehicle#"]?actualData["Vehicle#"]:"N/A",
//                        DriverNo:actualData["Driver#"]?actualData["Driver#"]:"N/A", Distance:0});
//                    }
                    // console.log(tripLatLng, actualData);
                    setMapData(tripLatLng);
                }
                
            }
            catch(err){console.log(err);}
        },
        AlwaysHiddenColumns: ["iServiceID","iForUser"]
    });
    //---------------------------------------------------Driver Penalty Alerts Table------------------------------------------------------
    const [driverPenaltyAlertDisplay, setDriverPenaltyAlertDisplay] = useState({
        height: 300,
        heightoffset: 600,
        calculateHeight: true,
        pagination: false,
        sortCondition: false,
        mapZoomOpts: {zoomControl: false, draggable: true, scrollWheel: true, disableDoubleClickZoom: false},
        mapDefaultBtns: false,
        mapOptions: {tilt: 47.5, zoom: 10},
        paginationMode: "local",
        paginationSize: 500,
        paginationSizeSelector: [500, 1000, 1500, 2000, 2500],
        selectable: 1,
        reactiveData:false, //enable data reactivity
        layout: "fitColumns",
        placeholder:"No Data Available",
        clipboard: false,
        selectableRangeMode: "click",
        GridName:"driverPenaltyAlert",
        paginationCounter:"",
        intervalTimer: GlobalASCSData.find(dict => dict.SubTitle === "Tb01") === undefined? 60000:GlobalASCSData.find(dict => dict.SubTitle === "Tb01").value*2000,
        movableColumns:true,
        vDefaultGridName: "SelectedGridRouteSRQARQPRQ_New",
        index: "ID",
        autoColumns: true,
        bSysUser: 1,
        intervalEnable: false,
        persistence: false,
        bWebApplySettingToAll: true,
        GridReturnOnlyIDColumnInRowData: false,
        containerClass: "col position-relative",
        Containerstyle: {},
        footerElement: '<button class="tabulator_btns" title="Export Excel" id="'
        +"driverPenaltyAlert"+'_Export" style="height:25px"></button>',
        tableDoubleClickFunc: function(table, row) {
        },
        footerElementHandles: function (table) {
            driverPenaltyAlertTableObj.current = table;
            driverPenaltyAlertTableObj.current.selectRow( driverPenaltyAlertTableObj.current.getData()[0].ID);
            let img = document.createElement("img");
                img.style.cssText = "width:16px; height:16px; margin-top:-25%;"; 
                img.src = ExportIcon;
                document.getElementById("driverPenaltyAlert_Export").appendChild(img);

            document.getElementById("driverPenaltyAlert_Export").addEventListener("click", function(){
                const data = table.getData('active');
                const columnsToIgnore = ['id'];
                let filteredData = data.map(row =>{
                    const filteredRow = {...row};
                    columnsToIgnore.forEach(column => delete filteredRow[column]);
                    return filteredRow;
                });
                
                const sheet = XLSX.utils.json_to_sheet(filteredData);
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, sheet, "driver Penalty Alerts Data");
                XLSX.writeFile(wb, "driverPenaltyAlertTable_data.xlsx");
                
            });
        },
        rowSelectionChangeHandle: function(data){ 
            try{
                if(data.length > 0)
                {
                    let actualData = data[0];
                    // console.log(actualData);
                    let tripLatLng = [];
                    if(actualData.TripLat && actualData.TripLat !== "" && actualData.TripLat !== 0)
                    {
                        tripLatLng.push({lat:parseFloat(actualData.TripLat),lng: parseFloat(actualData.TripLong), Type:"PU", name:"N/A", address:"N/A"});
                    }
//                    else
//                    {
//                        tripLatLng.push({lat:"",lng: "", Type:"PU", name:"N/A", address:"N/A"});
//                    }
                    if(actualData.Lat && actualData.Lat !== "" && actualData.Lat !== 0)
                    {
                        tripLatLng.push({lat:parseFloat(actualData.Lat),lng: parseFloat(actualData.Long), Type:"Alert", description:actualData["Penalty Reason"], name:"Driver Penalty", address:"N/A"});
                    }
//                    else
//                    {
//                        tripLatLng.push({lat:"",lng: "", Type:"Alert", description:actualData["Penalty Reason"], name:"Driver Penalty", address:"N/A"});
//                    }
                    if(actualData.DriverLat && actualData.DriverLat !== "" && actualData.DriverLat !== 0)
                    {
                        tripLatLng.push({lat:parseFloat(actualData.DriverLat),lng: parseFloat(actualData.DriverLong), VehInfo:("" +" "+"SEDAN"), 
                            State: "ONLINE", Type:"Vehicle", VehNo:actualData["Vehicle#"], DriverNo:actualData["Driver#"], Distance:0});
                    }
                    else
                    {
                        tripLatLng.push({lat:"",lng: "", VehInfo:("" +" "+"SEDAN"), 
                            State: "ONLINE", Type:"Vehicle", VehNo:actualData["Vehicle#"], DriverNo:actualData["Driver#"], Distance:0});
                    }
                    // console.log(tripLatLng);
                    setMapData(tripLatLng);
                    setPenaltyStatusExpiration(actualData["Penalty Left"]);
                    setPenaltyStatus((actualData.IsActive? "Active":"Removed"));
                    // penaltyStatusBtnCheck.current.textContent = (actualData.IsActive?"Remove":"Add");
                    // if(penaltyStatusBtnCheck.current.textContent === "Remove")
                    // {
                    //     penaltyStatusTextRef.current.className = "fw-bold text-danger";
                    // }
                    // else
                    // {
                    //     penaltyStatusTextRef.current.className = "fw-bold text-success";
                    // }
                }
                else
                {
                    setMapData([]);
                }
            }
            catch(err){console.log(err);}
        },
        AlwaysHiddenColumns: ["iRejectedServiceID"]
    });
    //---------------------------------------------------Functions Begin
    useEffect(() => {
        try{
            // console.log(props.selectedAff);
            // setAffSelection(props.selectedAff);
            if(props.selectedAff){
                affSelection.current = props.selectedAff;
                if (!isLoading)
                {
                    LoadingNoShowReasonByAffiliate(affSelection.current);
                }
                
            }
        }
        catch(err){console.log(err);}
    }, [props.selectedAff]);


    useEffect(() => {
        if (!isLoading && affSelection.current != null && affSelection.current != 0) {
          LoadingNoShowReasonByAffiliate(affSelection.current);
        }
      }, [isLoading]);

    const handleCloseDriverAlerts = ()=>{
        setShowEmergencyAlerts(false);
        setShowNoShowAlerts(false);
        setShowLateAlerts(false);
        setShowDeviceAlerts(false);
        setShowDriverPenaltyAlerts(false);
        setShowOthersAlerts(false);
        props.setShowDriverAlerts(false);
    };

    const handleOpenEmergencyAlerts = ()=>{
        console.log("reloading");
    };

    const emergencyAlertDescription = (e)=>{
        setEmergencyAlertStatusDescription(e.target.value);
    };

    const othersAlertDescription = (e)=>{
        setOtherAlertStatusDescription(e.target.value);
    };

    const noShowAlertDescription = (e)=>{
        setNoShowAlertStatusDescription(e.target.value);
    };

    const handleTitleClick = async(text)=>{
        try{
            setShowLoader(false);
            setShowInfoWindow(false);
            setMapData([]);
            generalDataofSelectedAlert.current = [];
            selectedAlertSectionTypeRef.current = text;
            // await getAllAlertsData();
            let textsArr = [
            {dataTableSetter: setEmergencyAlertsTableData, setShowTab:setShowEmergencyAlerts, driverDataRows: responseDataRef.current[0], ref:EmergencyBtnRef.current, text:"emergency"}, 
            {dataTableSetter: setNoShowAlertsTableData, setShowTab:setShowNoShowAlerts, driverDataRows: responseDataRef.current[1], ref:NoShowBtnRef.current, text:"noshow"}, 
            {dataTableSetter: setLatePUAlertsTableData, setShowTab:setShowLateAlerts, driverDataRows: responseDataRef.current[2], ref:LatePUBtnRef.current, text:"latePU"}, 
            {dataTableSetter: setDeviceLockAlertsTableData, setShowTab:setShowDeviceAlerts, driverDataRows: responseDataRef.current[3], ref:DeviceBtnRef.current, text:"device"}, 
            {dataTableSetter: setDriverPenaltyAlertsTableData, setShowTab:setShowDriverPenaltyAlerts, driverDataRows: responseDataRef.current[4], ref:DriverBtnRef.current, text:"driver"}, 
            {dataTableSetter: setOtherAlertsTableData, setShowTab:setShowOthersAlerts, driverDataRows: responseDataRef.current[5], ref:OthersBtnRef.current, text:"others"}];
            
            for(let j = 0; j < textsArr.length; j++)
            {
                if(text === textsArr[j].text)
                {
                    
                    if(responseDataRef.current[j] && responseDataRef.current[j].length > 0)
                    {
                        textsArr[j].ref.style.backgroundColor = "#769bcc";
                        textsArr[j].dataTableSetter([responseDataRef.current[j][0]]);
                        textsArr[j].setShowTab(true);
                        generalDataofSelectedAlert.current = textsArr[j];
                        handleGeneralListRowSelection(0);
                    }
                    else
                    {
                        textsArr[j].ref.style.backgroundColor = "#769bcc";
                        textsArr[j].setShowTab(true);
                        generalDataofSelectedAlert.current = textsArr[j];
                    }
                }
                else
                {
                    if(textsArr[j].ref)
                    {
                        textsArr[j].ref.style.backgroundColor = "";
                    }
                    textsArr[j].setShowTab(false);
                }
            }
            
        }
        catch(err){console.log(err);}
        
    };

    const handleGeneralListRowSelection = (index)=>{
        try{
            // console.log(generalDataofSelectedAlert.current, index);
            generalDataofSelectedAlert.current.dataTableSetter([generalDataofSelectedAlert.current.driverDataRows[index]]);
            let tableData = [];
            if(selectedAlertSectionTypeRef.current === "noshow")
            {
                setTimeout(async() => {
                    if(generalDataofSelectedAlert.current.driverDataRows.length > 0)
                    {
                        tableData = driverEmergencyAlertTableObj.current.getData()[0];
                        if(tableData !== undefined && tableData !== "" && tableData !== null){
                            xCancelSourceForGrid.current = APICom.GenerateSource();
                            let loadData = {
                                "iServiceID": (tableData.iServiceID?parseInt(tableData.iServiceID):0)
                            };
                            let loadAlarmResponse = await APICom.fetchData("main","TripActions/LoadEditOARAAlarm", "post", {}, loadData, xCancelSourceForGrid.current);
                            const objAlarm =JSON.parse(loadAlarmResponse.data)
                            setOARALoadData(objAlarm[0]);
                            if(objAlarm[0].bReturnTrip === true &&  noShowStatusDropDown.toLowerCase() === "approved"){
                                setAlertHasReturnTrip(true);
                                setIsReturnTripChecBox(false);
                            }
                            else{
                                setAlertHasReturnTrip(false);
                                setIsReturnTripChecBox(false);
                            }
                        }
                        
                        // console.log(loadAlarmResponse.data);
                    }
                }, 500);
            }
            else if(selectedAlertSectionTypeRef.current === "device")
            {
                let deviceData = generalDataofSelectedAlert.current.driverDataRows[index];
                let startTime = (deviceData.dtLockStartTime && deviceData.dtLockStartTime.includes("T")? new Date(deviceData.dtLockStartTime) : "");
                let endTime = (deviceData.dtDeviceLockExpiration && deviceData.dtDeviceLockExpiration.includes("T") ? new Date(deviceData.dtDeviceLockExpiration) : "");
                let duration = (startTime !== "" && endTime !== "" ? Math.abs(endTime-startTime) : 0);
                let durationInHours = Math.floor(duration / (1000 * 60 * 60));
                let [date, time] = (deviceData.dtDeviceLockExpiration && deviceData.dtDeviceLockExpiration.includes("T")? deviceData.dtDeviceLockExpiration.split("T") : ["", ""]);
                setDeviceLockExpirationDuration(durationInHours);
                if(date !== "")
                {
                    time = time.split(':').slice(0, 2).join(':');
                    setDeviceLockExpirationStartTime(time);
                    setDeviceLockExpirationStartDate(date);
                }
                else
                {
                    setDeviceLockExpirationStartTime("");
                    setDeviceLockExpirationStartDate("");
                }
                
            }
            
        }
        catch(err){console.log(err);}
    };
    
    const handleDeviceStatusChange = (e)=>{
        if(e.target.textContent.includes("Unlock"))
        {
            deviceStatusBtnCheck.current.textContent = "Lock";
            setDeviceStatus("UnLocked");
            deviceStatusTextRef.current.className = "fw-bold text-success";
        }
        else
        {
            deviceStatusBtnCheck.current.textContent = "Unlock";
            setDeviceStatus("Locked");
            deviceStatusTextRef.current.className = "fw-bold text-danger";
        }
    };

    const handlePenaltyStatusChange = async(e)=>{
        try{
            if(e.target.textContent.includes("Remove"))
            {
                penaltyStatusBtnCheck.current.textContent = "Add";
                setPenaltyStatus("Removed");
                setPenaltyStatusExpiration("N/A");
                penaltyStatusTextRef.current.className = "fw-bold text-success";
            }
            else
            {
                penaltyStatusBtnCheck.current.textContent = "Remove";
                setPenaltyStatus("Active");
                let selectedRowData = driverPenaltyAlertTableObj.current.getData()[0];
                setPenaltyStatusExpiration(selectedRowData["Penalty Left"]);
                penaltyStatusTextRef.current.className = "fw-bold text-danger";
            }
        }
        catch(err){console.log(err);}
    };

    const handleChangeNoShowStatusDropDown = (e)=>{
        if(e.target.value.toLowerCase() === "approved"){
            if(OARALoadData?.bReturnTrip === true){
                setAlertHasReturnTrip(true);
                setIsReturnTripChecBox(false);
            }
            else{
                setAlertHasReturnTrip(false);
                setIsReturnTripChecBox(false);
            }
        }
        else if(e.target.value.toLowerCase() === "declined"){
            setAlertHasReturnTrip(false);
            setIsReturnTripChecBox(false);
        }
        setNoShowStatusDropDown(e.target.value);
    };
    const handleChangeNoShowReasonDropDown = (e)=>{
        const item = noShowReasons.find((item) => {
            return (item.id === Number(e.target.value)) 
        });
        if(item != undefined && item?.description != ""){
            setNoShowReasonDropDown(item.description);
            noshowReasonRef.current = item.id;
        }
        else{
            setNoShowReasonDropDown("No Show");
            //noshowReasonRef.current = "No Show";
        }
    };

   

    const getAllAlertsData = async()=>{
        try{
            refreshBtnRef.current.disabled = true;
            setShowLoader(true);
            let data = {
                "selectedAffiliate": affSelection.current
            };
            responseDataRef.current = [];
            xCancelSourceForGrid.current = APICom.GenerateSource();
            let response = await APICom.fetchData("main","TripActions/GetAlarms", "post", {}, data, xCancelSourceForGrid.current);
            refreshBtnRef.current.disabled = false;
            let emergencyArr = [];
            let noshowArr = [];
            let latePUArr = (response.data.LateDetails && response.data.LateDetails.length > 0) ? response.data.LateDetails : [];
            let deviceLockArr = (response.data.DeviceLocked && response.data.DeviceLocked.length > 0) ? response.data.DeviceLocked : [];
            let othersArr = [];
            let driverPenaltyArrForSelAff = (response.data.DriverPenalty && response.data.DriverPenalty.length > 0) ? response.data.DriverPenalty : [];
            let alarmsArr = response.data.AlertDetails;
            let alertsArr = response.data.AlertDetails;

            if(alarmsArr && alarmsArr.length > 0)
            {
                for(let k = 0; k < alarmsArr.length; k++)
                {

                        if(alarmsArr[k]["Alert Type"] === "")
                        {
                            othersArr.push(alarmsArr[k]);
                        }
                        else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("emergency"))
                        {
                            emergencyArr.push(alarmsArr[k]);
                        }
                        else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("noshow"))
                        {
                            let bReturnTrip = false;
                            try {
                                bReturnTrip = response.data.Alarms.find(p => p.iServiceID === alarmsArr[k].iServiceID).bReturnTrip;

                            } catch (error) {
                                bReturnTrip = false;
                            }
                            alarmsArr[k].bReturnTrip = bReturnTrip;

                            noshowArr.push(alarmsArr[k]);
                        }
                        // else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("late"))
                        // {
                        //     latePUArr.push(alarmsArr[k]);
                        // }
                        // else if(alarmsArr[k]["Alert Type"].toLowerCase().includes("device"))
                        // {
                        //     deviceLockArr.push(alarmsArr[k]);
                        // }
                }
            }
            // else if(alertsArr && alertsArr.length > 0)
            // {
            //     for(let k = 0; k < alertsArr.length; k++)
            //     {
            //         if(parseInt(alertsArr[k].iAlertAffiliateID) === affSelection.current)
            //         {
            //             if(alertsArr[k]["Alert Type"] === "")
            //             {
            //                 othersArr.push(alertsArr[k]);
            //             }
            //             else if(alertsArr[k]["Alert Type"].toLowerCase().includes("emergency"))
            //             {
            //                 emergencyArr.push(alertsArr[k]);
            //             }
            //             else if(alertsArr[k]["Alert Type"].toLowerCase().includes("noshow"))
            //             {
            //                 noshowArr.push(alertsArr[k]);
            //             }
            //             // else if(alertsArr[k]["Alert Type"].toLowerCase().includes("late"))
            //             // {
            //             //     latePUArr.push(alertsArr[k]);
            //             // }
            //             // else if(alertsArr[k]["Alert Type"].toLowerCase().includes("device"))
            //             // {
            //             //     deviceLockArr.push(alertsArr[k]);
            //             // }
            //         }
            //     }
            // }

            setEmergencyAlertDriver((emergencyArr.length > 0 ? emergencyArr:[]));
            setNoShowAlertDriver((noshowArr.length > 0 ? noshowArr:[]));
            setLatePUAlertDriver((latePUArr.length > 0 ? latePUArr:[]));
            setDeviceLockAlertDriver((deviceLockArr.length > 0 ? deviceLockArr:[]));
            setDriverPenaltyAlertDriver((driverPenaltyArrForSelAff.length > 0? driverPenaltyArrForSelAff:[]));
            setOtherAlertDriver((othersArr.length > 0 ? othersArr:[]));
            if (deviceLockAlertDriver.length == 0) {
                setDeviceLockAlertsTableData([]);
            }
            responseDataRef.current = [(emergencyArr.length > 0? emergencyArr:[]), (noshowArr.length > 0? noshowArr:[]), 
                (latePUArr.length > 0? latePUArr:[]), (deviceLockArr.length > 0? deviceLockArr:[]), 
                (driverPenaltyArrForSelAff.length > 0? driverPenaltyArrForSelAff:[]),(othersArr.length > 0? othersArr:[])
            ];
            // console.log("here is the array:",responseDataRef.current);
            let alertsTextsArr = ["emergency", "noshow", "latePU", "device", "driver", "others"];
            let overallCount = 0;
            if(AlertClickFlagRef.current)
            {
                AlertClickFlagRef.current = false;
                for(let k = 0; k < responseDataRef.current.length; k++)
                {
                    if(responseDataRef.current[k].length > 0)
                    {
                        overallCount+=1;
                        handleTitleClick(alertsTextsArr[k]);
                        return;
                    }
                }
                if(overallCount === 0)
                {
                    generalDataofSelectedAlert.current = [];
                    setMapData([]);
                    setEmergencyAlertsTableData([]);
                    setNoShowAlertsTableData([]);
                    setLatePUAlertsTableData([]);
                    setDeviceLockAlertsTableData([]);
                    setDriverPenaltyAlertsTableData([]);
                    setOtherAlertsTableData([]);
                    setPenaltyStatusExpiration("N/A");
                }
            }
            setShowLoader(false);
        }
        catch(err){console.log(err);}
    };
    

    const handleSaveRemoveAlertRow = async()=>{
        try{
            ResolveBtnRef.current.disabled = true;
            let data = {
                "vDescription": "",
                "isResolved": false,
                "iAlertID": 0,
                "iUserID": 0
            };
            let deviceData = {
                "iCurrentVehicleID": 0,
                "iMDTID": 0,
                "vDeviceLockReason": "",
                "vLockedPerson": "",
                "isLock": false,
                "iDeviceLockExpiration": 0,
                "dtDeviceLockStartDateTime": ""
            };
            let lateAlarmData = {
                "AlarmID": 0,
                "iUserID": 0
            };
            let driverPenaltyAPIData = {
                "penaltyStart": "",
                "iDriverID": 0,
                "penaltyHour": 0,
                "penaltyMileage": 0,
                "penaltyReason": "",
                "iUserID": 0
            };
            let tableData = [];
            // console.log(loginData);
            if(selectedAlertSectionTypeRef.current === "driver")
            {
                if(generalDataofSelectedAlert.current?.driverDataRows?.length > 0)
                {
                    tableData = driverPenaltyAlertTableObj.current.getData()[0];
                }
            }
            else
            {
                if(generalDataofSelectedAlert.current?.driverDataRows?.length > 0)
                {
                    tableData = driverEmergencyAlertTableObj.current.getData()[0];
                }
            }

            if(selectedAlertSectionTypeRef.current === "emergency")
            {
                if(tableData)
                {
                    data.vDescription = emergencyAlertStatusDescription;
                    data.isResolved = true;
                    data.iAlertID = parseInt(tableData.iAlertID);
                    data.iUserID = parseInt(loginData.iUserID);
                }
            }
            else if(selectedAlertSectionTypeRef.current === "noshow")
            {
                if(tableData)
                {
                    data.vDescription = noShowAlertStatusDescription;
                    data.isResolved = noShowStatusDropDown.toLowerCase().includes("approve") ? true:false;
                    data.iAlertID = parseInt(tableData.iAlertID);
                    data.iUserID = parseInt(loginData.iUserID);
                }
            }
            else if(selectedAlertSectionTypeRef.current === "latePU")
            {
                if(tableData)
                {
                    // data.vDescription = latePUAlertStatusDescription;
                    // data.isResolved = true;
                    // data.iAlertID = parseInt(tableData.iAlertID);
                    // data.iUserID = parseInt(loginData.iUserID);
                    lateAlarmData.AlarmID = parseInt(tableData["Alarm ID"]);
                    lateAlarmData.iUserID = parseInt(loginData.iUserID);
                    // setLatePUAlertServiceID(tableData.ServiceID);
                }
            }
            else if(selectedAlertSectionTypeRef.current === "device")
            {
                if(tableData)
                {
                    deviceData.iCurrentVehicleID = parseInt(tableData.IVEHICLEID);
                    deviceData.iMDTID = parseInt(tableData.iMDTID);
                    deviceData.vDeviceLockReason = deviceLockStatusDescription;
                    deviceData.vLockedPerson = loginData.vUserName;
                    if (deviceStatus.toLowerCase() === "unlocked"){
                        deviceData.isLock = false;
                    }
                    else {
                        deviceData.isLock = true;
                    }
                    deviceData.iDeviceLockExpiration = (deviceStatus.toLowerCase().includes("locked")?(deviceLockExpirationDuration!==''?parseInt(deviceLockExpirationDuration):0):0);
                    deviceData.dtDeviceLockStartDateTime = (deviceStatus.toLowerCase().includes("locked")?deviceLockExpirationStartDate+" "+deviceLockExpirationStartTime:"");
                }
            }
            else if(selectedAlertSectionTypeRef.current === "driver")
            {
                if(tableData)
                {
                    let penaltySt = tableData["Penalty Start"].split("T")[1].split(":")[0] +":"+ tableData["Penalty Start"].split("T")[1].split(":")[1];
                    driverPenaltyAPIData.penaltyStart = tableData["Penalty Start"]? tableData["Penalty Start"].split("T")[0]+" "+penaltySt:"";
                    driverPenaltyAPIData.iDriverID = parseInt(tableData.iDriverID);
                    driverPenaltyAPIData.penaltyHour = parseInt(tableData["Penalty Hrs."])? String(tableData["Penalty Hrs."]):'0';
                    driverPenaltyAPIData.penaltyMileage = String(tableData["Penalty Mileage"]);
                    driverPenaltyAPIData.penaltyReason = driverPenaltyStatusDescription;
                    driverPenaltyAPIData.iUserID = parseInt(loginData.iUserID);
                }
            }
            else if(selectedAlertSectionTypeRef.current === "others")
            {
                if(tableData)
                {
                    data.vDescription = otherAlertStatusDescription;
                    data.isResolved = true;
                    data.iAlertID = parseInt(tableData.iAlertID);
                    data.iUserID = parseInt(loginData.iUserID);
                }
            }
            if(selectedAlertSectionTypeRef.current !== "driver" && selectedAlertSectionTypeRef.current !== "device" && selectedAlertSectionTypeRef.current !== "latePU")
            {
                xCancelSourceForGrid.current = APICom.GenerateSource();
                let response = await APICom.fetchData("main","TripActions/ResolveAlertMessages", "post", {}, data, xCancelSourceForGrid.current);
                if(response.data && response.data.toLowerCase().includes("success"))
                {
                    handleTitleClick(selectedAlertSectionTypeRef.current);
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert successfully resolved!");
                    setShowDynamicModal(true);
                    refreshBtnRef.current.click();
                    if(selectedAlertSectionTypeRef.current === "emergency")
                    {
                        setEmergencyAlertStatusDescription("");
                        if(emergencyAlertDriver.length === 0)
                        {
                            setEmergencyAlertsTableData([]);
                        }
                    }
                    else if(selectedAlertSectionTypeRef.current === "noshow")
                    {
                        let noShowOARAData = {
                            "iRefid": parseInt(OARALoadData.alarmRefID),
                            "internalNotes": String(noShowReasonDropDown),
                            "iUserID": parseInt(loginData.iUserID),
                            "vUserName": String(loginData.vUserName),
                            "iAffiliateID": parseInt(affSelection.current),
                            "bRemove": false,
                            "alarmID": parseInt(OARALoadData.AlarmID),
                            "alarmStatus": "1",
                            "alarmCode": String(OARALoadData.AlarmCode),
                            "operatorAction": "",
                            "alarmServiceID": parseInt(OARALoadData.ServiceID),
                            "alarmVehicleID": parseInt(OARALoadData.VehicleID),
                            "alarmDeviceNo": (parseInt(OARALoadData.SDNo)? parseInt(OARALoadData.SDNo):0),
                            "alarmDeviceLat": OARALoadData.DeviceLat? OARALoadData.DeviceLat: 0.0,
                            "alarmDeviceLong": OARALoadData.DeviceLong? OARALoadData.DeviceLong: 0.0,
                            "pickupZone": String(OARALoadData.pickupzone),
                            "FirstInZoneNS": true,
                            "ShowFavorDialog": true,
                            "CheckInOnStand": true,
                            "bReturnTrip": isReturnTripCheckBox,//chkReturnTripRef.current.checked,//OARALoadData.bReturnTrip,
                            "NoShowReasonID": -1,
                            "OtherNoShowComments": String(noShowAlertStatusDescription),
                            "cmbNoShowStaus" : String(noShowStatusDropDown)
                        };
                        xCancelSourceForGrid.current = APICom.GenerateSource();
                        let saveNoShowResponse = await APICom.fetchData("main","TripActions/SaveLoadEditOARAAlarm", "post", {}, noShowOARAData, xCancelSourceForGrid.current);
                        setNoShowAlertStatusDescription("");
                        AlertClickFlagRef.current = true;
                        getAllAlertsData();
                        setAlertHasReturnTrip(false);
                        // if(noshowAlertDriver.length === 0)
                        // {
                        //     setNoShowAlertsTableData([]);
                        // }
                    }
                    else if(selectedAlertSectionTypeRef.current === "others")
                    {
                        setOtherAlertStatusDescription("");
                        if(otherAlertDriver.length === 0)
                        {
                            setOtherAlertsTableData([]);
                        }
                    }
                }
                else if(response.data && response.data.toLowerCase().includes("fail"))
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert resolve failed, please try again later.");
                    setShowDynamicModal(true);
                }
                else
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML(response.error);
                    setShowDynamicModal(true);
                }
            }
            else if(selectedAlertSectionTypeRef.current === "device")
            {
                //Device Unlock/lock API
                xCancelSourceForGrid.current = APICom.GenerateSource();
                let response = await APICom.fetchData("main","TripActions/LockUnlockDevice", "post", {}, deviceData, xCancelSourceForGrid.current);
                if(response.data && response.data.toLowerCase().includes("success"))
                {
                    handleTitleClick(selectedAlertSectionTypeRef.current);
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert successfully resolved!");
                    setShowDynamicModal(true);
                    setDeviceLockStatusDescription("");
                    if(deviceLockAlertDriver.length === 0)
                    {
                        setDeviceLockAlertsTableData([]);
                    }
                    refreshBtnRef.current.click();
                }
                else if(response.data && response.data.toLowerCase().includes("fail"))
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert resolve failed, please try again later.");
                    setShowDynamicModal(true);
                }
                else
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML(response.error);
                    setShowDynamicModal(true);
                }
            }
            else if(selectedAlertSectionTypeRef.current === "driver")
            {
                //Driver Penalty API
                xCancelSourceForGrid.current = APICom.GenerateSource();
                let response = await APICom.fetchData("main","TripActions/ResolveDriverPenalty", "post", {}, driverPenaltyAPIData, xCancelSourceForGrid.current);
                if(response.data && response.data.toLowerCase().includes("success"))
                {
                    handleTitleClick(selectedAlertSectionTypeRef.current);
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Driver penalty successfully removed!");
                    setShowDynamicModal(true);
                    setDriverPenaltyStatusDescription("");
                    if(driverPenaltyAlertDriver.length === 0)
                    {
                        setDriverPenaltyAlertsTableData([]);
                    }
                    refreshBtnRef.current.click();
                }
                else if(response.data && response.data.toLowerCase().includes("fail"))
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert resolve failed, please try again later.");
                    setShowDynamicModal(true);
                }
                else
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML(response.error);
                    setShowDynamicModal(true);
                }
                
            }
            else if(selectedAlertSectionTypeRef.current === "latePU")
            {
                //Late PU API
                xCancelSourceForGrid.current = APICom.GenerateSource();
                let response = await APICom.fetchData("main","TripActions/ResolveLateAlarms", "post", {}, lateAlarmData, xCancelSourceForGrid.current);
                if(response.data && response.data.toLowerCase().includes("success"))
                {
                    handleTitleClick(selectedAlertSectionTypeRef.current);
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert successfully resolved!");
                    setShowDynamicModal(true);
                    setLatePUAlertStatusDescription("");
                    refreshBtnRef.current.click();
                    if(latePUAlertDriver.length === 0)
                    {
                        setLatePUAlertsTableData([]);
                    }
                }
                else if(response.data && response.data.toLowerCase().includes("fail"))
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML("Alert resolve failed, please try again later.");
                    setShowDynamicModal(true);
                }
                else
                {
                    setModalHeaderText("Agile Dispatch Action Alert");
                    setModalBodyHTML(response.error);
                    setShowDynamicModal(true);
                }
            }
            
            ResolveBtnRef.current.disabled = false;
        }
        catch(err){console.log(err); setAlertHasReturnTrip(false);}
    };

    const handleDeviceDurationCases = (e)=>{
        try{
            if(e.target.value.includes("-") || e.target.value > 120){e.target.value = '';}
        }
        catch(err){console.log(err);}
    };

    const handleReturnTripCheckBox = () => {
        setIsReturnTripChecBox(prevValue => {
            const nextValue = !prevValue;
            chkReturnTripRef.current = nextValue;
            return nextValue;
          });
    }
    
    useEffect(() => {
        try{
            if(props.showDriverAlerts)
            {
                setPageLoaded(true);
                AlertClickFlagRef.current = true;
                getAllAlertsData();
            }
            else
            {
                setPageLoaded(false);
            }
        }
        catch(err){console.log(err);}
    }, [props.showDriverAlerts]);

    useEffect(() => {
        try{
            if(pageLoaded)
            {
                let autoRefresh = setInterval(() => {
                    if(refreshBtnRef.current)
                    {
                        if(!refreshBtnRef.current.disabled)
                        {
                            getAllAlertsData();
                        }
                    }
                    else
                    {
                        clearInterval(autoRefresh);
                    }
                }, 60000); 
            }
            
        }
        catch(err){console.log(err);}
    }, [pageLoaded]);
    
    useEffect(() => {
        try{
            //Set default value
            setNoShowStatusDropDown("approved");
            setAlertHasReturnTrip(false);
            setIsReturnTripChecBox(false);
            //Set default value

            LoadingNoShowReasonByAffiliate();
        }
        catch(err){console.log(err);}
        return () => {
            setAlertHasReturnTrip(false);
        };
    }, []);



    const LoadingNoShowReasonByAffiliate = () => {
        affSelection.current = props.selectedAff;
        if(affSelection.current == null || affSelection.current == undefined) {return;}
        const NoShowData = NoShowReasonData[affSelection.current];
        const NoShowReasonJSON = (NoShowData !== undefined && NoShowData !== null && NoShowData !== "") ? JSON.parse(NoShowData) : undefined;
        if(NoShowReasonJSON){
          const noshowReasonByAffiliate = [];
          noshowReasonByAffiliate.push({"name": "Select reason ...", "id": -1, "description": "" });
          NoShowReasonJSON.map((item) => {
            return noshowReasonByAffiliate.push({"name": item.vTitle, "id": item.iId, "description": item.vDescription });
          })
          if(noshowReasonByAffiliate.length > 0)
          {
            setNoShowReasons(noshowReasonByAffiliate);
          }
        }else{
          //setNoShowAlert({...noShowAlert, alertTitle: 'NoShow Reasons', alertMsg:'Error loading noshow reasons!'});
          //setDisplayNoShowAlert(true);
          return false;
        }
    }

    
    const handleAlertModalClose = () => {
         //Set default value
         setNoShowStatusDropDown("approved");
         setAlertHasReturnTrip(false);
         setIsReturnTripChecBox(false);
         //Set default value
        
        setDisplayNoShowAlert(false);

    }

    return(
        <>
            { displayNoShowAlert && <Modal centered show={displayNoShowAlert} onHide={handleAlertModalClose} animation={false}>
                <Modal.Header className='noshow_dialog_header_bgcolor' style={{height: "50px"}} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{noShowAlert.alertTitle}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body><b>{noShowAlert.alertMsg}</b></Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                    </Modal.Footer>
                </Modal>
            }

        {props.showDriverAlerts ? 
        <Modal centered backdrop="static" size='xl' keyboard={true} show={props.showDriverAlerts} onHide={handleCloseDriverAlerts} animation={true}>
            <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none' closeButton>
                {/* <Icon icon="bx:bell"  className='text-white mx-2' style={{width:"30px", height:"30px"}}/> */}
                <Modal.Title className='w-100 text-center'>
                    System Alerts
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='user-select-none'>
                {showLoader ? <div className="loader"></div> : ""}
                <Row className='w-100 text-center overflow-auto m-0 rounded shadow-sm bg-dark p-1' style={{fontSize:"small"}}>
                    <Col className='p-0 px-1 text-nowrap'>
                        <p className='m-0 user-select-none text-white fw-bold border rounded shadow-sm columnChooserRows py-1' ref={EmergencyBtnRef} onClick={(e)=>{handleTitleClick("emergency")}}>
                            <span className='d-inline-flex text-white text-start float-start'><Icon icon="bx:error" style={{width:"20px", height:"20px"}}/></span>
                            Emergency 
                            <span className='m-0 d-inline-flex text-danger px-1'>{emergencyAlertDriver.length}</span>
                        </p>
                    </Col>
                    <Col className='p-0 px-1 text-nowrap'>
                        <p className='m-0 user-select-none text-white fw-bold border rounded shadow-sm columnChooserRows py-1' ref={NoShowBtnRef} onClick={(e)=>{handleTitleClick("noshow")}}>
                            <span className='d-inline-flex text-white text-start float-start'><Icon icon="bx:user-x" style={{width:"20px", height:"20px"}}/></span>
                            N/S Request
                            <span className='m-0 d-inline-flex text-danger px-1'>{noshowAlertDriver.length}</span>
                        </p>
                    </Col>
                    <Col className='p-0 px-1 text-nowrap'>
                        <p className='m-0 user-select-none text-white fw-bold border rounded shadow-sm columnChooserRows py-1' ref={LatePUBtnRef} onClick={(e)=>{handleTitleClick("latePU")}}>
                            <span className='d-inline-flex text-white text-start float-start'><Icon icon="bx:time-five" style={{width:"20px", height:"20px"}}/></span>
                            Late Trips
                            <span className='m-0 d-inline-flex text-danger px-1'>{latePUAlertDriver.length}</span>
                        </p>
                    </Col>
                    <Col className='p-0 px-1 text-nowrap'>
                        <p className='m-0 user-select-none text-white fw-bold border rounded shadow-sm columnChooserRows py-1' ref={DeviceBtnRef} onClick={(e)=>{handleTitleClick("device")}}>
                            <span className='d-inline-flex text-white text-start float-start'><Icon icon="bx:lock-alt" style={{width:"20px", height:"20px"}}/></span>
                            Device Lock
                            <span className='m-0 d-inline-flex text-danger px-1'>{deviceLockAlertDriver.length}</span>
                        </p>
                    </Col>
                    <Col className='p-0 px-1 text-nowrap'>
                        <p className='m-0 user-select-none text-white fw-bold border rounded shadow-sm columnChooserRows py-1' ref={DriverBtnRef} onClick={(e)=>{handleTitleClick("driver")}}>
                            <span className='d-inline-flex text-white text-start float-start'><Icon icon="bx:taxi" style={{width:"20px", height:"20px"}}/></span>
                            Driver Penalty
                            <span className='m-0 d-inline-flex text-danger px-1'>{driverPenaltyAlertDriver.length}</span>
                        </p>
                    </Col>
                    <Col className='p-0 px-1 text-nowrap'>
                        <p className='m-0 user-select-none text-white fw-bold border rounded shadow-sm columnChooserRows py-1' ref={OthersBtnRef} onClick={(e)=>{handleTitleClick("others")}}>
                            <span className='d-inline-flex text-white text-start float-start'><Icon icon="bx:server" style={{width:"20px", height:"20px"}}/></span>
                            Others
                            <span className='m-0 d-inline-flex text-danger px-1'>{otherAlertDriver.length}</span>
                        </p>
                    </Col>
                </Row>
                <Row className='w-100 mt-2 m-0 py-0' style={{height:"500px"}}>
                    <span className='m-0 fw-bold small border-bottom'>
                        {generalDataofSelectedAlert.current.text === "emergency"?
                            <>
                                {"Emergency Alerts"} 
                                <span className='m-1 fw-normal'><Icon icon="bx:info-circle" 
                                    onMouseOver={(e)=>setShowInfoWindow(true)} onMouseLeave={(e)=>setShowInfoWindow(false)} className='text-secondary' 
                                    style={{marginTop:"-0.5%", cursor: "pointer", width:"15px", height:"15px"}}/>
                                </span>
                                {showInfoWindow? <div className="position-absolute d-inline-flex bg-white float-end p-2 shadow-sm my-0 mt-1 text-dark rounded border fw-normal" 
                                    style={{zIndex:"999999", width:"115px", fontSize:"small"}}>{infoWindowState.current}</div>
                                :""}
                            </>
                        :generalDataofSelectedAlert.current.text === "noshow"?
                            <>
                                {"No Shows"} 
                                <span className='m-1 fw-normal'><Icon icon="bx:info-circle" 
                                    onMouseOver={(e)=>setShowInfoWindow(true)} onMouseLeave={(e)=>setShowInfoWindow(false)} className='text-secondary' 
                                    style={{marginTop:"-0.5%", cursor: "pointer", width:"15px", height:"15px"}}/>
                                </span>
                                {showInfoWindow? <div className="position-absolute d-inline-flex bg-white float-end p-2 my-0 mt-1 shadow-sm text-dark rounded border fw-normal" 
                                    style={{zIndex:"999999", width:"115px", fontSize:"small"}}>{infoWindowState.current}</div>
                                :""}
                                {/* <span style={{paddingLeft: "10px",color: "red",fontWeight: "normal"}}>Note: Select a trip from the left menu to get the latest details about return leg(s).</span> */}
                            </>
                        :generalDataofSelectedAlert.current.text === "latePU"?
                            <>
                                {"Late Trips"}
                                <span className='m-1 fw-normal'><Icon icon="bx:info-circle" 
                                    onMouseOver={(e)=>setShowInfoWindow(true)} onMouseLeave={(e)=>setShowInfoWindow(false)} className='text-secondary' 
                                    style={{marginTop:"-0.5%", cursor: "pointer", width:"15px", height:"15px"}}/>
                                </span>
                                {showInfoWindow? <div className="position-absolute d-inline-flex bg-white float-end p-2 my-0 mt-1 shadow-sm text-dark rounded border fw-normal" 
                                    style={{zIndex:"999999", width:"115px", fontSize:"small"}}>{infoWindowState.current}</div>
                                :""}
                            </>
                        :generalDataofSelectedAlert.current.text === "device"?
                            "Device Locks"
                        :generalDataofSelectedAlert.current.text === "driver"?
                            <>
                                {"Driver Penalties"} 
                                <span className='m-1 fw-normal'><Icon icon="bx:info-circle" 
                                    onMouseOver={(e)=>setShowInfoWindow(true)} onMouseLeave={(e)=>setShowInfoWindow(false)} className='text-secondary' 
                                    style={{marginTop:"-0.5%", cursor: "pointer", width:"15px", height:"15px"}}/>
                                </span>
                                {showInfoWindow? <div className="position-absolute d-inline-flex bg-white float-end p-2 my-0 mt-1 shadow-sm text-dark rounded border fw-normal" 
                                    style={{zIndex:"999999", width:"115px", fontSize:"small"}}>{infoWindowState.current}</div>
                                :""}
                            </>
                        :generalDataofSelectedAlert.current.text === "others"?
                            "Others"
                        :""}
                    </span>
                    <Col xs={3} className='overflow-auto border-end border-3' style={{height:"490px"}}>
                        {generalDataofSelectedAlert.current.driverDataRows? 
                            generalDataofSelectedAlert.current.driverDataRows.map((item,index)=>{
                                if(generalDataofSelectedAlert.current.text === "driver")
                                {
                                    return(
                                        <Row key={index} className='driverAlertSelection border-bottom border-warning' style={{cursor:"pointer"}} onClick={()=>{handleGeneralListRowSelection(index)}}>
                                            <Col xs={2} className='m-auto' style={{fontSize:"small"}}>
                                                <Icon icon="bx:taxi" className='text-warning' style={{width:"20px",height:"20px"}}/>
                                            </Col>
                                            <Col className='' style={{fontSize:"small"}}>
                                                <p className='m-0 fw-bold'>For Driver: {item["Driver Name"] && item["Driver Name"].replace(/\s/g, '') !== ""? item["Driver Name"]:"N/A"}</p>
                                                <p className='m-0 text-muted'>D: {item["Driver#"]} & V: {item["Vehicle#"]} 
                                                    {item.State ? 
                                                        (item.State.toLowerCase().includes("online")?
                                                        <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-success' style={{height:"10px", width:"10px"}}></span>
                                                        :item.State.toLowerCase().includes("irtpu") || item.State.toLowerCase().includes("in route")?
                                                        <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"purple", height:"10px", width:"10px"}}></span>
                                                        :item.State.toLowerCase().includes("location")?
                                                        <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-info' style={{height:"10px", width:"10px"}}></span>
                                                        :item.State.toLowerCase().includes("occupied")?
                                                        <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-warning' style={{height:"10px", width:"10px"}}></span>
                                                        :item.State.toLowerCase().includes("break")?
                                                        <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"yellow", height:"10px", width:"10px"}}></span>
                                                        :item.State.toLowerCase().includes("disconnected")?
                                                        <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-secondary' style={{height:"10px", width:"10px"}}></span>
                                                        :"")
                                                    :""}
                                                </p> 
                                                <p className='m-0 text-muted'>Expiration: {item["Penalty Left"]?item["Penalty Left"]:""}</p>
                                                <p className='m-0' style = {{color: "#1212de"}}>{item["Penalty Start"].split("T")[0]} {item["Penalty Start"].split("T")[1]}</p>
                                            </Col>
                                        </Row>
                                    );
                                }
                                else if(generalDataofSelectedAlert.current.text === "latePU")
                                {
                                    return(
                                        <Row key={index} className=' driverAlertSelection border-bottom border-warning' style={{cursor:"pointer"}} onClick={()=>{handleGeneralListRowSelection(index)}}>
                                            <Col xs={2} className='m-auto' style={{fontSize:"small"}}>
                                                <Icon icon="bx:time-five" className='text-warning' style={{width:"20px",height:"20px"}}/>
                                            </Col>
                                            <Col style={{fontSize:"small", marginBottom:"5px"}}>
                                                <p className='m-0'>Pickup Person: {item["PUPersonName"]}</p>
                                                <p className='m-0 fw-bold'>Trip #: {item["Confirmation #"] === ""? "UnAssigned":item["Confirmation #"]}
                                                {item.State ? 
                                                            (item.State.toLowerCase().includes("online")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-success' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("irtpu") || item.State.toLowerCase().includes("in route")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"purple", height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("location")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-info' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("occupied")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-warning' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("break")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"yellow", height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("disconnected")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-secondary' style={{height:"10px", width:"10px"}}></span>
                                                            :"")
                                                        :""}
                                                
                                                </p>
                                                <p className='m-0 text-muted'>{item["Alarm Code"] && item["Alarm Code"].replace(/\s/g, '') !== ""? item["Alarm Code"]:"late"} </p>
                                                <p className='m-0'>Pickup Time: {item["Alarm Time"]}</p>
                                                <p className='m-0' style = {{color: "#1212de"}}>{item.AlertStartTime}</p>
                                            </Col>
                                        </Row>
                                    );
                                }
                                else if(generalDataofSelectedAlert.current.text === "others")
                                {
                                    let vehicleNum = "";
                                    let reason = "";
                                    let newTime = new Date(item.dtCreationDate);
                                    let time = (parseInt(newTime.getHours())<10?"0"+newTime.getHours():newTime.getHours())+":"+
                                        (parseInt(newTime.getMinutes())<10?"0"+newTime.getMinutes():newTime.getMinutes());
                                    let year = (parseInt(newTime.getMonth())+1)+"/"+newTime.getDate()+"/"+newTime.getFullYear();
                                    // let meridiem = parseInt(newTime.getHours()) >=12 ? "PM":"AM";
                                    // console.log(newTime);
                                    if(item.vAlertMessage)
                                    {
                                        if(item.vAlertMessage.toLowerCase().includes("v:"))
                                        {
                                            vehicleNum = item.vAlertMessage.split(" ")[0].split(":")[1];
                                        }
                                        else if(item.vAlertMessage.toLowerCase().includes("veh#:"))
                                        {
                                            vehicleNum = item.vAlertMessage.replace(/\s/g, '').split(",")[1].split(":")[1];
                                        }

                                        if(item.vAlertMessage.includes("Device Data"))
                                        {
                                            reason = "Data Usage";
                                        }
                                        else if(item.vAlertMessage.includes("Backseat"))
                                        {
                                            reason = "Backseat Launcher";
                                        }
                                        else if(item.vAlertMessage.includes("Power"))
                                        {
                                            reason = "Device Power";
                                        }
                                        else if(item.vAlertMessage.includes("PIM"))
                                        {
                                            reason = "PIM Disconnect";
                                        }
                                    }
                                    else
                                    {
                                        vehicleNum = (item["Vehicle#"] ? item["Vehicle#"] : (item.IVEHICLEID ? item.IVEHICLEID : ""));
                                        reason = (item.IDEVICEID?  "Device "+ item.STATE : "");
                                    }
                                    return(
                                        <Row key={index} className='driverAlertSelection border-bottom border-warning' style={{cursor:"pointer"}} onClick={()=>{handleGeneralListRowSelection(index)}}>
                                            <Col xs={2} className='m-auto' style={{fontSize:"small"}}>
                                                <Icon icon="bx:server" className='text-warning' style={{width:"20px",height:"20px"}}/>
                                            </Col>
                                            <Col className=''  style={{fontSize:"small"}}>
                                                <p className='m-0 fw-bold'>Reason: {reason}</p>
                                                <p className='m-0 text-muted'>Driver: {item.iUserID} - Vehicle: {vehicleNum}</p>
                                                <p className='m-0'>{year} {time}</p>
                                            </Col>
                                        </Row>
                                    );
                                }
                                else
                                {
                                    let vehicleNum = "";
                                    let rider = "";
                                    let newTime = new Date(item.dtCreationDate);
                                    let time = (parseInt(newTime.getHours())<10?"0"+newTime.getHours():newTime.getHours())+":"+
                                        (parseInt(newTime.getMinutes())<10?"0"+newTime.getMinutes():newTime.getMinutes());
                                    let year = (parseInt(newTime.getMonth())+1)+"/"+newTime.getDate()+"/"+newTime.getFullYear();
                                    let deviceLockExpirationStart = (item.dtDeviceLockExpiration && item.dtDeviceLockExpiration !== ""? item.dtDeviceLockExpiration : "");
                                    let yearFormatted = "";
                                    let timeFormatted = "";
                                    let startDateTime = "";
                                    if(deviceLockExpirationStart !== "")
                                    {
                                        deviceLockExpirationStart = (deviceLockExpirationStart.includes("T") ? deviceLockExpirationStart.split("T"): deviceLockExpirationStart.split(" "));
                                        yearFormatted = (deviceLockExpirationStart[0].includes("/") ? deviceLockExpirationStart[0]: 
                                            (deviceLockExpirationStart[0].split("-")[1]+"/"+deviceLockExpirationStart[0].split("-")[2]+"/"+deviceLockExpirationStart[0].split("-")[0])
                                        );
                                        timeFormatted = deviceLockExpirationStart[1].split(':').slice(0, 2).join(':');;
                                        startDateTime = (yearFormatted +" "+ timeFormatted);
                                    }
                                    // let meridiem = parseInt(newTime.getHours()) >=12 ? "PM":"AM"; "2024-11-04T08:27:00"
                                    // console.log(newTime);
                                    if(item.vAlertMessage)
                                    {
                                        if(item.vAlertMessage.toLowerCase().includes("v:"))
                                        {
                                            vehicleNum = item.vAlertMessage.split(" ")[0].split(":")[1];
                                        }
                                        else if(item.vAlertMessage.toLowerCase().includes("veh#:"))
                                        {
                                            vehicleNum = item.vAlertMessage.replace(/\s/g, '').split(",")[1].split(":")[1];
                                        }
                                    }
                                    else
                                    {
                                        vehicleNum = (item["Vehicle#"] ? item["Vehicle#"] : (item.IVEHICLEID ? item.IVEHICLEID : ""));
                                    }
                                    // let rider = item.vAlertMessage?.split("PU Person:")[1].split(", Time")[0];
                                    if(generalDataofSelectedAlert.current.text === "emergency")
                                    {
                                        return(
                                            <Row key={index} className='driverAlertSelection border-bottom border-warning' style={{cursor:"pointer"}} onClick={()=>{handleGeneralListRowSelection(index)}}>
                                                <Col xs={2} className='m-auto' style={{fontSize:"small"}}>
                                                    <Icon icon="bx:error" className='text-warning' style={{width:"20px",height:"20px"}}/>
                                                </Col>
                                                <Col className='' style={{fontSize:"small", marginBottom:"5px"}}>
                                                    <p className='m-0 fw-bold'>From Driver: {item["Driver Name"] && item["Driver Name"].replace(/\s/g, '') !== ""? item["Driver Name"]:"N/A"}</p>
                                                    <p className='m-0 text-muted'>D: {item.iUserID} & V: {vehicleNum}
                                                        {item.State ? 
                                                            (item.State.toLowerCase().includes("online")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-success' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("irtpu") || item.State.toLowerCase().includes("in route")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"purple", height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("location")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-info' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("occupied")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-warning' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("break")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"yellow", height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("disconnected")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-secondary' style={{height:"10px", width:"10px"}}></span>
                                                            :"")
                                                        :""}
                                                    </p>
                                                    <p className='m-0 text-muted'>{year} {time}</p>
                                                    <p className='m-0' style = {{color: "#1212de"}}>{item.AlertStartTime}</p>
                                                </Col>
                                            </Row>
                                        );
                                    }
                                    else if(generalDataofSelectedAlert.current.text === "noshow")
                                    {
                                        return(
                                            <Row key={index} className='driverAlertSelection border-bottom border-warning' style={{cursor:"pointer"}} onClick={()=>{handleGeneralListRowSelection(index)}}>
                                                <Col xs={2} className='m-auto' style={{fontSize:"small"}}>
                                                    <Icon icon="bx:user-x" className='text-warning' style={{width:"20px",height:"20px"}}/>
                                                </Col>
                                                <Col className='' style={{fontSize:"small", marginBottom:"5px"}}>
                                                    <p className='m-0 fw-bold'>Driver: {item["Driver Name"] && item["Driver Name"].replace(/\s/g, '') !== ""? item["Driver Name"]:"N/A"}</p>
                                                    <p className='m-0 text-muted'>Request a No Show for '<span className='m-0 fw-bold'>{item.PUPersonName !== ""?item.PUPersonName:"N/A"}</span>'
                                                        {item.State ? 
                                                            (item.State.toLowerCase().includes("online")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-success' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("irtpu") || item.State.toLowerCase().includes("in route")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"purple", height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("location")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-info' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("occupied")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-warning' style={{height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("break")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end' style={{backgroundColor:"yellow", height:"10px", width:"10px"}}></span>
                                                            :item.State.toLowerCase().includes("disconnected")?
                                                            <span title={item.State} className='mt-3 rounded-circle d-inline-flex float-end bg-secondary' style={{height:"10px", width:"10px"}}></span>
                                                            :"")
                                                        :""}
                                                    </p>
                                                    <p className='m-0'>{year} {time}</p>
                                                    <p className='m-0' style = {{color: "#1212de"}}>{item.AlertStartTime}</p>
                                                </Col>
                                            </Row>
                                        );
                                    }
                                    else if(generalDataofSelectedAlert.current.text === "device")
                                    {
                                        return(
                                            <Row key={index} className='driverAlertSelection border-bottom border-warning' style={{cursor:"pointer"}} onClick={()=>{handleGeneralListRowSelection(index)}}>
                                                <Col xs={2} className='m-auto' style={{fontSize:"small"}}>
                                                    <Icon icon="bx:lock-alt" className='text-warning' style={{width:"20px",height:"20px"}}/>
                                                </Col>
                                                <Col className='' style={{fontSize:"small"}}>
                                                    <p className='m-0 fw-bold'>Device #: {item.IDEVICEID && item.IDEVICEID!==""? item.IDEVICEID:"Unknown"}</p>
                                                    <p className='m-0 text-muted'>D: {(item.IDRIVERID && item.IDRIVERID !== "" && item.IDRIVERID !== -1? item.IDRIVERID : "UNKWN")} & V: {vehicleNum}</p>
                                                    <p className='m-0'>{startDateTime}</p>
                                                </Col>
                                            </Row>
                                        );
                                    }
                                    
                                }
                            
                            }) 
                        :   <Row className='h-100 border border-warning'>
                                <Col className='driverAlertSelection'>
                                    <p className='m-0 text-center'>No Data Available</p>
                                </Col>
                            </Row>
                        }
                    </Col>
                    <Col xs={9} className='overflow-auto' style={{height:"500px"}}>
                        <Row className='m-0' style={{height:"300px"}}>
                            {generalDataofSelectedAlert.current.text === "emergency"? 
                                <GridControl ReloadDataFunction={handleOpenEmergencyAlerts} Data={emergencyAlertsTableData} options={driverEmergencyAlertDisplay}/>
                            :generalDataofSelectedAlert.current.text === "noshow"?
                                <GridControl ReloadDataFunction={handleOpenEmergencyAlerts} Data={noShowAlertsTableData} options={driverEmergencyAlertDisplay}/>
                            :generalDataofSelectedAlert.current.text === "latePU"?
                                <GridControl ReloadDataFunction={handleOpenEmergencyAlerts} Data={latePUAlertsTableData} options={driverEmergencyAlertDisplay}/>
                            :generalDataofSelectedAlert.current.text === "device"?
                                <GridControl ReloadDataFunction={handleOpenEmergencyAlerts} Data={deviceLockAlertsTableData} options={driverEmergencyAlertDisplay}/>
                            :generalDataofSelectedAlert.current.text === "driver"?
                                <GridControl ReloadDataFunction={handleOpenEmergencyAlerts} Data={driverPenaltyAlertsTableData} options={driverPenaltyAlertDisplay}/>
                            :generalDataofSelectedAlert.current.text === "others"?
                                <GridControl ReloadDataFunction={handleOpenEmergencyAlerts} Data={otherAlertsTableData} options={driverEmergencyAlertDisplay}/>
                            :""}
                            
                        </Row>
                        <Row className='m-0' style={{height:"100px"}}>
                            <Col xs={6} className='border p-0'>
                                {/*vehData={vehData} DispatchDriverData={DispatchDriverData}*/}
                                <MapControlSkeleton
                                    zones={ZoneVerticesData.Table}
                                    MapDetailData={mapData} 
                                    options={driverEmergencyAlertDisplay}
                                    DispatchVehicleData={DispatchVehicleData}
                                /> 
                            </Col>
                            <Col xs={6} className='border'>
                                <Row>
                                    <Col className='p-2'>
                                        {generalDataofSelectedAlert.current.text === "emergency"?
                                        <>
                                            <textarea rows={8} cols={8} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" 
                                                placeholder="Enter a description here"
                                                value={emergencyAlertStatusDescription} onChange={emergencyAlertDescription}
                                            />
                                            {/* <p className='m-0 d-inline-flex'>Resolved?</p>
                                            <input type='checkbox' value={emergencyAlertResolved} onChange={(e)=>{setEmergencyAlertResolved(e.target.checked)}} 
                                                className='mx-1 d-inline-flex' style={{cursor:"pointer"}}/> */}
                                        </>
                                        :""}
                                        {generalDataofSelectedAlert.current.text === "noshow"?
                                        <>
                                            <Row>
                                                <Col xs={6}>
                                                    <select className='form-select d-inline-flex text-center rounded w-100' value={noShowStatusDropDown}
                                                    onChange={handleChangeNoShowStatusDropDown} title='Select a status'
                                                    >
                                                        {/* <option value={"defaultStatus"} disabled hidden>Select a status</option> */}
                                                        <option value={"approved"}>Approved</option>
                                                        <option value={"declined"}>Declined</option>
                                                    </select>
                                                </Col>
                                                <Col xs={6}>
                                                    <select className='form-select d-inline-flex text-center rounded w-100'
                                                    onChange={handleChangeNoShowReasonDropDown} title='Select a reason' ref={noshowReasonRef} 
                                                    >
                                                    {noShowReasons.map(({ id, name }, index) => <option key={id} value={id} >{name}</option>)} 
                                                     
                                                        {/* <option value={"defaultReason"} disabled hidden>Select a reason</option> */}
                                                        {/* <option value={"customerNoShow"}>Customer No Show</option>
                                                        <option value={"driverNoShow"}>Driver No Show</option> */}
                                                    </select>
                                                </Col>
                                                {alertHasReturnTrip && (
                                                    <Form.Check
                                                    type="checkbox"
                                                    label="No-Show with return leg(s)"
                                                    id="chkReturnTrips"
                                                    onChange={handleReturnTripCheckBox}
                                                    checked={isReturnTripCheckBox}
                                                    ref={chkReturnTripRef}
                                                    className="cancel_dialog_returncheckbox_color"
                                                    style={{marginLeft: "15px"}}
                                                    />
                                                )}
                                            </Row>

                                            <Row>
                                                <Col>
                                                    <textarea rows={6} cols={8} style={{resize:"none"}} className="tripDetails-label-dataFields float-start mt-2 w-100" 
                                                        placeholder="Comments"
                                                        value={noShowAlertStatusDescription} onChange={noShowAlertDescription}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                        :""}
                                        {generalDataofSelectedAlert.current.text === "latePU"?
                                        <>
                                            <textarea rows={8} cols={8} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" 
                                                placeholder="Enter a description here"
                                                value={latePUAlertStatusDescription} onChange={(e)=>{setLatePUAlertStatusDescription(e.target.value);}}
                                            />
                                            {/* <p className='m-0 d-inline-flex'>Resolved?</p>
                                            <input type='checkbox' value={latePUAlertResolved} onChange={(e)=>{setLatePUAlertResolved(e.target.checked)}} 
                                                className='mx-1 d-inline-flex' style={{cursor:"pointer"}}/> */}
                                        </>
                                        :""}
                                        {generalDataofSelectedAlert.current.text === "device"?
                                        <>
                                            <Row>
                                                <Col xs={9}>
                                                    <p className='p-0 m-0 fw-bold' style={{fontSize:"small"}}>Device Status: <span ref={deviceStatusTextRef} className='fw-bold text-danger'>{deviceStatus}</span></p>
                                                    {deviceStatus.toLowerCase() === "locked"? 
                                                        <>
                                                            <Row className='m-0 d-flex w-100'>
                                                                <p className='p-0 m-0 fw-bold' style={{fontSize:"small"}}>Expiration Date & Time:</p>
                                                                <Col xs={6} className='mt-1 p-0'>
                                                                    <input type={"date"} value={deviceLockExpirationStartDate} 
                                                                        onChange={(e)=>setDeviceLockExpirationStartDate(e.target.value)} title={"Expiration Start Date"} 
                                                                        className='w-100 text-nowrap text-center d-inline-flex rounded border-1 p-1' required
                                                                    /> 
                                                                </Col>
                                                                <Col xs={6} className='mt-1'>
                                                                    <input type={"time"} value={deviceLockExpirationStartTime} 
                                                                        title={"Expiration Start Time"} onChange={(e)=>setDeviceLockExpirationStartTime(e.target.value)}
                                                                        className='w-100 text-nowrap text-center d-inline-flex rounded border-1 p-1' required
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row className='m-0 mt-1 w-100'>
                                                                <Col xs={6} className='p-0'>
                                                                    <p className='p-0 m-0 fw-bold' style={{fontSize:"small"}}>Duration (Hours):</p>
                                                                    
                                                                </Col>
                                                                <Col xs={6}>
                                                                    <input type={"number"} value={deviceLockExpirationDuration} min={0} max={120} onInput={handleDeviceDurationCases} 
                                                                        onChange={(e)=>setDeviceLockExpirationDuration(e.target.value)} title={"Expiration Duration (Hours)"} 
                                                                        className='w-100 text-center text-nowrap d-inline-flex rounded border-1 p-1' required
                                                                    /> 
                                                                </Col>
                                                            </Row>
                                                        </>
                                                    :""}
                                                </Col>
                                                <Col xs={3}>
                                                    <Button variant='dark' className='border-0 float-end' 
                                                        ref={deviceStatusBtnCheck} onClick={handleDeviceStatusChange}>Unlock
                                                    </Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <textarea rows={(deviceStatus.toLowerCase() === "locked"?2:6)} cols={8} style={{resize:"none"}} className="tripDetails-label-dataFields mt-2 float-start w-100" 
                                                        placeholder="Comments"
                                                        value={deviceLockStatusDescription} onChange={(e)=>{setDeviceLockStatusDescription(e.target.value)}}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                        :""}
                                        {generalDataofSelectedAlert.current.text === "driver"?
                                        <>
                                            <Row className='m-0'>
                                                <Col className='p-0'>
                                                    <p className='m-0 fw-bold' style={{fontSize:"small"}}>Status: <span ref={penaltyStatusTextRef} className='fw-bold text-danger'>{penaltyStatus}</span></p>
                                                    <p className='m-0 fw-bold' style={{fontSize:"small"}}>Expiration: <span className='fw-bold text-muted'>{penaltyStatusExpiration}</span></p>
                                                </Col>
                                                {/* <Col xs={6} className='p-0'>
                                                    <Button variant='dark' className='border-0 float-end' 
                                                        ref={penaltyStatusBtnCheck} onClick={handlePenaltyStatusChange}>Remove
                                                    </Button>
                                                </Col> */}
                                            </Row>
                                            <textarea rows={6} cols={8} style={{resize:"none"}} className="mt-2 tripDetails-label-dataFields float-start w-100" 
                                                placeholder="Comments"
                                                value={driverPenaltyStatusDescription} onChange={(e)=>{setDriverPenaltyStatusDescription(e.target.value)}}
                                            />
                                        </>
                                        :""}
                                        {generalDataofSelectedAlert.current.text === "others"?
                                        <>
                                            <textarea rows={8} cols={8} style={{resize:"none"}} className="tripDetails-label-dataFields float-start w-100" 
                                                placeholder="Enter a description here"
                                                value={otherAlertStatusDescription} onChange={othersAlertDescription}
                                            />
                                        </>
                                        :""}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='dark' ref={refreshBtnRef} className="border-0" onClick={getAllAlertsData}>
                    {"Refresh"}
                    <Icon icon="bx:refresh"  className='text-white' style={{width:"20px", height:"20px"}}/>
                </Button>
                <Button ref={ResolveBtnRef} variant='dark' className="border-0" onClick={handleSaveRemoveAlertRow} disabled={generalDataofSelectedAlert.current?.driverDataRows?.length === 0 || generalDataofSelectedAlert.current.length === 0}>
                    {"Resolve"}
                </Button>
                <Button variant='secondary' className="border-0" onClick={handleCloseDriverAlerts}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
        : ""}
        {showDynamicModal ? 
                <Modal centered backdrop="static" keyboard={true} onHide={()=>setShowDynamicModal(false)} show={showDynamicModal} animation={true}>
                    <Modal.Header className='text-white activate_dialog_header_bgcolor user-select-none p-0 py-1 px-2' closeButton>
                        <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
                    <Modal.Footer className='p-0 px-2 py-1'>
                        <Button variant='secondary' className="border-0" onClick={()=>setShowDynamicModal(false)}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
        : ""}
        </>
    );

};

export default DriverAlerts;